import React from 'react';
import { StoreProvider } from './src/hooks/useStore';

import './src/styles/tailwind.css';

export const wrapRootElement = ({ element }) => <StoreProvider>{element}</StoreProvider>;
